export const Group = {
  ADMINISTRATING: 16,
  BACKUP: 25,
  CDN: 26,
  COLOCATION: 1,
  CUSTOM: 10,
  DDOS_PROTECTION: 24,
  DEDICATED: 2,
  DOMAINS: 17,
  ISP_MANAGER: 9,
  MONITORING: 12,
  NETWORK: 4,
  NETWORK_EQUIPMENT: 15,
  NOTIFICATION: 14,
  OPEN_RACK: 8,
  OPTICAL_LINKS: 27,
  RACKS: 6,
  SELECTEL_CHAT: 29,
  SOFTWARE: 18,
  SOLUTION: 11,
  STORAGE: 21,
  UNIVERSAL: 5,
  VDS_LINUX: 3,
  VDS_WINDOWS: 7,
  VEEAM_CLOUD_CONNECT: 28,
  VMWARE: 23,
  VPC: 22,
  XEN_CLOUD: 20
}

export const AdditionalGroup = {
  AGENT: 6,
  CLOUD_LINUX: 4,
  DDOS_PROTECTION: 7,
  FIREWALL: 5,
  GSUITE: 10,
  ISP_SYSTEM: 3,
  MICROSOFT: 1,
  PLESK: 2,
  QRATOR: 12,
  VEEAM_CLOUD_CONNECT: 11,
  VOLS_MSK: 9,
  VOLS_SPB: 8
}

export const SubType = {
  ADDITIONAL: 2,
  MAIN: 1
}

export const Status = {
  ACTIVE: 4,
  DEACTIVATED: 1,
  DEPRECATED: 2,
  HIDDEN: 3
}